
import fundamentalSheetConstants from '@/constants/fundamental.constants';
export default {
    name: "FundTimeFrameSelector",

    props: {
        selectedTimeFrame: {
            type: Number,
            default: null,
        }
    },

    emits: ['onChanged',],

    created() {
        this.fundamentalTimeFrames = fundamentalSheetConstants.fundamentalTimeFrames
        this.timeFrames = [
            this.fundamentalTimeFrames['3year'],
            this.fundamentalTimeFrames['5year'],
            this.fundamentalTimeFrames['10year'],
            this.fundamentalTimeFrames['25year'],
            this.fundamentalTimeFrames['max'],
        ]
    },
}
